import { get, put, post } from "./authenticatedrequestUtil";
import { PlaidLinkResponse } from "../../types/plaidLinkResponse";

export const getPlaidLink = get<PlaidLinkResponse>(({ companyId }) => `/${companyId}/plaid/create-link`);

export const putPlaidAccounts = put<{}>(
  ({ companyId, public_token }) =>
    `/${companyId}/plaid?public_token=${public_token}`
);

export const getPlaidTransactions = get<{}>(
  ({ companyId }) => `/${companyId}/plaid/transactions`
);
